import { render, staticRenderFns } from "./VideoEditor.vue?vue&type=template&id=5a3e74aa"
import script from "./VideoEditor.vue?vue&type=script&lang=js"
export * from "./VideoEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a3e74aa')) {
      api.createRecord('5a3e74aa', component.options)
    } else {
      api.reload('5a3e74aa', component.options)
    }
    module.hot.accept("./VideoEditor.vue?vue&type=template&id=5a3e74aa", function () {
      api.rerender('5a3e74aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/views/VideoEditor.vue"
export default component.exports